import { render, staticRenderFns } from "./ChallengeOverviewPage.vue?vue&type=template&id=3108c4b5&"
import script from "./ChallengeOverviewPage.vue?vue&type=script&lang=ts&"
export * from "./ChallengeOverviewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports